/* eslint-disable react-hooks/exhaustive-deps */
import { ArrowLeft, Search } from 'lucide-react'
import { useEffect, useState } from 'react'
import {
  Button,
  Card,
  Col,
  Container,
  Modal,
  Row,
  Table
} from 'react-bootstrap'
import { useNavigate, useParams } from 'react-router-dom'
import TablePagination from '../../../components/atoms/Table/TablePagination'
import api from '../../../config/AxiosInstance'
import * as Common from '../../../utils/Common'

const SamplingTimbang = () => {
  const { inbound_id } = useParams()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [selectedItem, setSelectedItem] = useState(null)
  const [samplingDetails, setSamplingDetails] = useState([])
  const [detailLoading, setDetailLoading] = useState(false)
  const [meta, setMeta] = useState({
    per_page: 10,
    current_page: 1,
    total_row: 0,
    total_page: 0
  })

  useEffect(() => {
    loadData()
  }, [inbound_id])

  useEffect(() => {
    if (showModal && selectedItem) {
      loadDetail(selectedItem, meta.current_page)
    }
  }, [showModal, selectedItem, meta.per_page, meta.current_page])

  const loadData = async () => {
    try {
      setLoading(true)
      const res = await api.get(
        `/inbound/pr-draft/sampling-material/${inbound_id}`
      )
      if (res.data.success) {
        setData(res.data.data)
      }
    } catch (err) {
      Common.showPopUpErrorMessage(
        err?.response?.data?.errors?.message || 'Error loading sampling data'
      )
    } finally {
      setLoading(false)
    }
  }

  const loadDetail = async (item, page = 1) => {
    try {
      setDetailLoading(true)
      const res = await api.get(
        `/inbound/pr-draft/sampling-detail/${inbound_id}/${item.item_batch_id}`,
        {
          params: {
            page: page,
            per_page: meta.per_page
          }
        }
      )
      if (res.data.success) {
        setSamplingDetails(res.data.data)
        setMeta(res.data.metadata)
      }
    } catch (err) {
      Common.showPopUpErrorMessage(
        err?.response?.data?.errors?.message || 'Error loading sampling details'
      )
    } finally {
      setDetailLoading(false)
    }
  }

  const handleOnChangeMeta = (e) => {
    setMeta((prev) => ({
      ...prev,
      per_page: parseInt(e.target.value, 10),
      current_page: 1
    }))
  }

  const handlePageChange = (data) => {
    setMeta((prev) => ({
      ...prev,
      current_page: data.selected + 1
    }))
  }

  const handleShowDetail = (item) => {
    setSelectedItem(item)
    setShowModal(true)
    setMeta((prev) => ({ ...prev, current_page: 1 }))
  }

  return (
    <Container fluid className="mt-4">
      <Row className="mb-4 align-items-center">
        <Col>
          <div className="d-flex align-items-center">
            <Button
              variant="link"
              className="text-dark p-0 me-3"
              onClick={() => navigate(-1)}
            >
              <ArrowLeft size={20} />
            </Button>
          </div>
        </Col>
      </Row>

      <Card className="border-0 shadow-sm">
        <Card.Body className="p-0">
          <Table responsive hover className="mb-0 custom-table">
            <thead className="bg-light">
              <tr>
                <th className="p-3 text-secondary" style={{ width: '50px' }}>
                  No
                </th>
                <th className="p-3 text-secondary">Item</th>
                <th className="p-3 text-secondary text-center">Batch</th>
                <th className="p-3 text-secondary text-center">
                  Total Sampling (pack)
                </th>
                <th className="p-3 text-secondary text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={5} className="text-center p-5">
                    Loading...
                  </td>
                </tr>
              ) : data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={index}>
                    <td className="p-3 align-middle">{index + 1}</td>
                    <td className="p-3 align-middle">
                      <div className="fw-semibold">{item.item_name}</div>
                    </td>
                    <td className="p-3 align-middle text-center">
                      {item.batch}
                    </td>
                    <td className="p-3 align-middle text-center">
                      {item.total_sampling_pack}
                    </td>
                    <td className="p-3 align-middle text-center">
                      <Button
                        variant="light"
                        size="sm"
                        className="bg-secondary bg-opacity-10 text-dark border-0"
                        onClick={() => handleShowDetail(item)}
                      >
                        <Search size={14} />
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5} className="text-center p-5">
                    No sampling data found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Card.Body>
      </Card>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title
            className="text-secondary fw-bold"
            style={{ fontSize: '1.1rem' }}
          >
            Sampling Timbang
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-2">
          {selectedItem && (
            <div className="mb-4">
              <div className="fw-bold text-dark" style={{ fontSize: '1rem' }}>
                {selectedItem.item_code} - {selectedItem.item_name}
              </div>
              <div className="fw-bold text-dark text-secondary small">
                {selectedItem.batch}
              </div>
            </div>
          )}

          <div className="border rounded">
            {detailLoading ? (
              <div className="text-center p-4">Loading details...</div>
            ) : samplingDetails.length > 0 ? (
              <Table hover size="sm" className="mb-0 custom-table">
                <thead className="bg-light">
                  <tr>
                    <th className="p-3 text-secondary" style={{ width: '60%' }}>
                      Sampling
                    </th>
                    <th className="p-3 text-secondary text-end">Berat</th>
                  </tr>
                </thead>
                <tbody>
                  {samplingDetails.map((sample, idx) => (
                    <tr key={sample.id} className="border-bottom">
                      <td className="p-3 text-secondary align-middle">
                        Sampling{' '}
                        {(meta.current_page - 1) * meta.per_page + idx + 1}
                      </td>
                      <td className="p-3 text-end text-warning fw-bold align-middle">
                        {sample.bruto} {sample.uom}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <div className="text-center p-4">No data</div>
            )}
          </div>

          <TablePagination
            meta={meta}
            handlePageChange={handlePageChange}
            handleOnChangeMeta={handleOnChangeMeta}
          />
        </Modal.Body>
      </Modal>
    </Container>
  )
}

export default SamplingTimbang
